var _classCallCheck = require("/home/admin/jenkins/workspace/mggroupsa_creditos-react_master@2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/admin/jenkins/workspace/mggroupsa_creditos-react_master@2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/admin/jenkins/workspace/mggroupsa_creditos-react_master@2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/admin/jenkins/workspace/mggroupsa_creditos-react_master@2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/admin/jenkins/workspace/mggroupsa_creditos-react_master@2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var Transport = require('winston-transport');

var CloudWatchClient = require('./cloudwatch-client');

var LogItem = require('./log-item');

var Relay = require('./relay');

var CloudWatchTransport =
/*#__PURE__*/
function (_Transport) {
  "use strict";

  _inherits(CloudWatchTransport, _Transport);

  function CloudWatchTransport(options) {
    var _this;

    _classCallCheck(this, CloudWatchTransport);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CloudWatchTransport).call(this, options));
    var client = new CloudWatchClient(options.logGroupName, options.logStreamName, options);
    _this._relay = new Relay(client, options);

    _this._relay.on('error', function (err) {
      return _this.emit('error', err);
    });

    _this._relay.start();

    return _this;
  }

  _createClass(CloudWatchTransport, [{
    key: "log",
    value: function log(info, callback) {
      var level = info.level;
      var msg = info.message;
      var meta = Object.assign({}, info);
      delete meta.level;
      delete meta.message;

      this._relay.submit(new LogItem(+new Date(), level, msg, meta, callback));
    }
  }]);

  return CloudWatchTransport;
}(Transport);

module.exports = CloudWatchTransport;